'use strict';

var React = require('react');

/* Stores */
var ModuleInspectorStore = require('stores/module-inspector');

/* Components */
var TitledGroup = require('components/ui/titled-group');
var TextField = require('components/ui/text-field');

var ModuleInspectorPropertyTypeNumber = React.createClass({
  displayName: 'ModuleInspectorPropertyTypeNumber',

  render: function render() {
    var component = this;
    var props = component.props;

    var placeholderText = ModuleInspectorStore.translate(props.groupName + '_' + props.name);

    return React.createElement(TextField, {
      ref: 'numberField',
      type: 'number',
      value: props.value,
      disabled: props.disabled,
      placeholder: placeholderText,
      description: placeholderText,
      onChange: component._onChange });
  },

  _onChange: function _onChange(evt) {
    var component = this;
    var props = component.props;
    var value = parseFloat(component.refs.numberField.value);

    // Force number fields to always return a value of type number
    if (isNaN(value)) {
      value = 0;
    }

    if (props.onChange) {
      /* Send original value and new value */
      props.onChange(props.value, value);
    }
  }
});

module.exports = ModuleInspectorPropertyTypeNumber;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/module/inspector/type/number.js
 **/